// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/c_div.css
// module id = Usr+
// module chunks = 1